import React, {PropTypes} from "react";
import Dialog from "material-ui/Dialog";
import ProfessionalDetails from "./ProfessionalDetails";
import OfferDetails from "./OfferDetails";
import CandidateDetails from "./CandidateDetails";

const styles = {
  dialogRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 0
  },
  dialogContent: {
    position: "relative",
    width: "80vw",
    transform: "",
    maxWidth: 'none'
  },
  dialogBody: {
    paddingBottom: 0
  }
};

class NewJoinerModal extends React.Component {

  constructor() {
    super();
  }

  render() {
    return (
      <div>
        {this.props.joinee != null ?
          <Dialog
            contentStyle={ styles.dialogContent }
            bodyStyle={ styles.dialogBody }
            style={ styles.dialogRoot }
            repositionOnUpdate={ false }

            autoDetectWindowHeight={true}
            titleStyle={{marginBottom: '0', borderBottom: 'solid 1px'}}
            autoScrollBodyContent={true}

            open={this.props.open}
            modal={false}
            title={this.props.joinee.name}
            onRequestClose={this.props.close}>
            <CandidateDetails data={this.props.joinee}/>
            <OfferDetails data={this.props.joinee}/>

            <ProfessionalDetails
              data={this.props.joinee}
            />

            &nbsp;
          </Dialog> : null}
      </div>
    );
  }
}

NewJoinerModal.propTypes = {};

export default NewJoinerModal;





/** WEBPACK FOOTER **
 ** ./src/feature/onboarding/components/NewJoinerModal.js
 **/